var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinDefaultLtr = function SvgPinDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 42a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50 0C31.775 0 17 14.904 17 33.29a33.4 33.4 0 0 0 3.853 15.624l26.784 49.67c1.004 1.86 3.628 1.888 4.68.081l9.056-16.713 8.736-16.171c4.365-8.095 7.51-13.962 9.062-16.913A33.4 33.4 0 0 0 83 33.29C83 14.905 68.225 0 50 0m0 5.428c15.254 0 27.62 12.474 27.62 27.862 0 4.61-1.11 9.054-3.203 13.034l-1.13 2.136A3936 3936 0 0 1 62.95 67.697L50.006 91.62 25.713 46.57a27.9 27.9 0 0 1-3.333-13.28C22.38 17.902 34.746 5.428 50 5.428",
    clipRule: "evenodd"
  })));
};
export default SvgPinDefaultLtr;